import {Pipe, PipeTransform} from "@angular/core";

@Pipe({name: "keyval"})
export class KeyValPipe implements PipeTransform {
    transform(value: any, ...args): any {
        if (!value) {
            return [];
        }
        return Object.keys(value).map(k => {
            return {key: k, value: value[k]};
        });
    }
}


// WEBPACK FOOTER //
// /opt/app/develop/src/app/pipes/keyval.pipe.ts